import { TipoArticuloApiInputProps, TipoArticuloInputProps } from '../interfaces/'

/**
 * Componemos el input a valores que acepta el servicio
 * @param input
 */
export const tipoArticuloComposeService = (
  input: TipoArticuloInputProps,
): TipoArticuloApiInputProps => {
  //@ts-ignore
  return {
    //codigo: input.codigo,
    descripcion: input.descripcion,
    notas: input.notas.map((item) => item.value),
  }
}
